import React from 'react';

const DocumentIcon = () => (
  <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.07 187.07">
    <g id="Single_Color_Design">
      <path d="m14.51,0c-4.08,0-7.52,1.4-10.32,4.2C1.4,6.99,0,10.43,0,14.51v158.04c0,4.08,1.4,7.52,4.2,10.32,2.8,2.8,6.24,4.2,10.32,4.2h115.04c4.08,0,7.52-1.4,10.32-4.2,2.8-2.8,4.2-6.24,4.2-10.32V41.93L102.14,0H14.51Zm123.64,172.56c0,2.15-.9,4.12-2.69,5.91s-3.76,2.69-5.91,2.69H14.51c-2.15,0-4.12-.9-5.91-2.69s-2.69-3.76-2.69-5.91v8.6V5.91v8.6c0-2.15.9-4.12,2.69-5.91,1.79-1.79,3.76-2.69,5.91-2.69h84.67v38.7h38.97v127.94Z" />
      <rect x="36.02" y="144.34" width="72.03" height="5.91" />
      <rect x="36.02" y="100.52" width="72.03" height="5.91" />
    </g>
  </svg>
);

export default DocumentIcon;
